import { SvgIcon } from '@mui/material';
import type { I18nFunctionType } from '../i18n/I18n';
import { PRESET_INDEX } from './columnVisibilitySelectorConstants';

export type ColumnVisibilityPreset = {
    label: string;
    icon: typeof SvgIcon;
    hidden: string[];
};

export {
    buildAllColumnsFavouriteModel,
    findOwnFavouritePreference,
    getFavouritePreferenceModel,
    getFavouritePresetLabel,
    isStaleSavedColumnViewFavourite,
    stripFavouriteFields
} from './columnVisibilityFavouriteUtils';
export type { PreferenceLike } from './columnVisibilityFavouriteUtils';
export function getColumnPresetLabel(
    selectedPreset: number,
    presets: ColumnVisibilityPreset[],
    t: I18nFunctionType,
    selectedSavedViewName?: string
): string | null {
    switch (selectedPreset) {
        case PRESET_INDEX.all:
            return t('grid.column.presets.all');
        case PRESET_INDEX.default:
            return t('grid.column.presets.default');
        case PRESET_INDEX.my:
            return t('grid.column.presets.my');
        case PRESET_INDEX.saved:
            return selectedSavedViewName ?? null;
        default:
            return presets?.[selectedPreset]?.label ?? null;
    }
}
